import { render, staticRenderFns } from "./SubjectViewUserInfoCard.vue?vue&type=template&id=1adb3527&"
import script from "./SubjectViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./SubjectViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports